export const ButtonLoadingState = Object.freeze({
	LOADING: 'LOADING',
	SAVING: 'SAVING',
	DONE: 'DONE',
	FAILED: 'FAILED',
	NONE: 'NONE',
});
